import React from 'react'
import { IconButton as MuiIconButton } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledIconButton = styled(MuiIconButton)(({ theme }) => ({
    '&:hover': {
        backgroundColor: 'transparent',
    },
}))

const IconButton = (props) => <StyledIconButton {...props} />

export default IconButton
